// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1Kba7","selected":"Chip_selected__2m7Yb"};